import { format } from 'date-fns';
import { useStoreState, useStoreActions } from 'easy-peasy';
import React from 'react'
import { useNavigate } from 'react-router-dom'
// import { useState,useContext } from 'react'
// import DataContext from './context/DataContext'

const NewPost = () => {
  // const [postTitle, setPostTitle] = useState('');
  //   const [postBody, setPostBody] = useState('');
  // const {handleSubmit}=useContext(DataContext)
  const navigate=useNavigate();
  const posts = useStoreState((state)=>state.posts);
  const postTitle = useStoreState((state)=>state.postTitle);
  const postBody = useStoreState((state)=>state.setPostBody);
  const savePost = useStoreActions((actions)=> actions.savePost);
  const setPostTitle=useStoreActions((actions) => actions.setPostTitle)
  const setPostBody=useStoreActions((actions) => actions.setPostBody)
  const handleSubmit = (e) => {
    e.preventDefault();
    const id = posts.length ? posts[posts.length - 1].id + 1 : 1;
    const datetime = format(new Date(), 'MMMM dd, yyyy pp');
    const newPost = { id, title: postTitle, datetime, body: postBody };
    savePost(newPost);
    navigate('/');
}
  return (
    <main className='NewPost'>
        <h2>Newpost</h2>
        <form  className="newPostForm" onSubmit={handleSubmit}>
          <label htmlFor="postTitle">Title:</label>
          <input 
          id="postTitle"
          type="text" 
          required
          value={postTitle}
          onChange={(e) => setPostTitle(e.target.value)}
          />
          <label htmlFor="postBody">Post:</label>
          <textarea 
             id="postBody"
             required
             value={postBody}
             onChange={(e)=> setPostBody(e.target.value)}
           
            />
          <button type="submit">Submit</button>
        </form>
    </main>
  )
}

export default NewPost